if (!customElements.get('bundle-value')) {
  class BundleValue extends HTMLElement {
    connectedCallback() {
      if (this.dataset.dynamicPricing !== 'true') return;

      this.regularValue = this.querySelector('[data-bundle-regular-value]');
      this.bundlePrice = this.querySelector('[data-bundle-price]');
      this.savings = this.querySelector('[data-bundle-savings]');
      this.variantName = this.querySelector('[data-bundle-variant-name]');

      if (
        typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.variantChange
      ) {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          this.update(event?.data?.variant);
        });
      }
    }

    disconnectedCallback() {
      if (typeof this.unsubscribe === 'function') this.unsubscribe();
    }

    update(variant) {
      if (!variant || typeof variant.price !== 'number') return;

      const compareAt = Number(variant.compare_at_price || 0);
      const hasSavings = compareAt > variant.price;

      if (this.bundlePrice) this.bundlePrice.textContent = this.formatMoney(variant.price);
      if (this.variantName) this.variantName.textContent = this.formatVariantLabel(variant);

      if (hasSavings) {
        if (this.regularValue) this.regularValue.textContent = this.formatMoney(compareAt);
        if (this.savings) this.savings.textContent = this.formatMoney(compareAt - variant.price);
      }

      this.classList.toggle('bundle-value--no-savings', !hasSavings);
    }

    formatMoney(cents) {
      const currency = this.dataset.currency || 'AUD';
      return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(cents / 100);
    }

    formatVariantLabel(variant) {
      const options = Array.isArray(variant.options)
        ? variant.options
        : String(variant.title || '').split(' / ');
      const firstSize = this.formatSizeLabel(options[0] || variant.title || '');

      if (this.dataset.productHandle === 'duuduu-duo-bundle' && options[1]) {
        return `${firstSize} + ${this.formatSizeLabel(options[1])}`;
      }

      return firstSize;
    }

    formatSizeLabel(value) {
      const option = String(value || '').trim();
      const sizes = ['King Single', 'Super King', 'Double', 'Queen', 'King'];
      const matchedSize = sizes.find((size) => option.toLowerCase().startsWith(size.toLowerCase()));

      return matchedSize || option.replace(/\s+\d+(?:\.\d+)?cm.*$/i, '').trim();
    }
  }

  customElements.define('bundle-value', BundleValue);
}
